{
  "regions": "Регионы",
  "serverTypes": "Типы серверов",
  "images": "Образы",
  "prices": "Цены",
  "region": "Регион",
  "zone": "Зона",
  "city": "Город",
  "type": "Тип",
  "family": "Семейство",
  "architecture": "Архитектура",
  "cpu": "vCPU",
  "memory": "RAM",
  "disk": "Диск",
  "traffic": "Трафик",
  "hourly": "В час",
  "monthly": "В месяц",
  "allFamilies": "Все семейства",
  "allArchitectures": "Все архитектуры",
  "families": {
    "cost_optimized": "Экономичные",
    "regular_purpose": "Обычные",
    "general_purpose": "Выделенные vCPU"
  },
  "cpuKind": {
    "shared": "общие",
    "dedicated": "выделенные"
  },
  "deprecated": "Выводится из оборота",
  "os": "ОС",
  "version": "Версия",
  "kind": "Вид",
  "rapidDeploy": "Быстрый запуск",
  "ipv4": "Публичный IPv4",
  "volume": "Том, за ГБ",
  "snapshot": "Снимок, за ГБ",
  "backups": "Резервные копии",
  "backupsValue": "{{percent}}\u00a0% от цены сервера",
  "netPrices": "Цены без НДС, {{currency}}.",
  "intro": "Что Hetzner предлагает этому проекту и по какой цене. Помогает выбрать сервер до его создания.",
  "serverTypesIntro": "Тип задаёт vCPU, память и диск. Цена почасовая с месячным пределом; от региона зависят цена и наличие.",
  "regionsIntro": "Расположение дата-центров. Частные сети соединяют серверы внутри одной сетевой зоны.",
  "imagesIntro": "Операционные системы и приложения, с которых может стартовать новый сервер.",
  "pricesIntro": "Цены на всё, что оплачивается сверх серверов.",
  "zoneHint": "Сетевая зона объединяет соседние площадки; частная сеть работает в пределах одной зоны.",
  "onlyAvailable": "Только доступные здесь",
  "unavailableShort": "Здесь не предлагается",
  "trafficHint": "Исходящий трафик, включённый в месяц; входящий бесплатен. Сверх лимита — оплата за каждый ТБ.",
  "imageKinds": {
    "system": "Система",
    "app": "Приложение",
    "snapshot": "Снимок",
    "backup": "Копия"
  },
  "ipv4Hint": "Каждый публичный IPv4-адрес оплачивается отдельно, даже не назначенный серверу. IPv6 бесплатен.",
  "volumeHint": "Дополнительное блочное хранилище для сервера, оплата по объёму.",
  "snapshotHint": "Копия диска сервера, которую вы храните и из которой можно создавать серверы, оплата по объёму.",
  "backupsHint": "Автоматические ежедневные копии, хранятся последние семь, цена — доля от цены сервера.",
  "hourlyMonthly": "{{hourly}} в час, не больше {{monthly}} в месяц",
  "perMonth": "{{price}} в месяц"
}
